import { birthdayData } from '../lib/data';
import styles from './Birthday.module.scss';

const Birthday = () => {

    return ( 
        <section>
             
                <div className = {styles.container}>
                    {birthdayData.map(({id, photo}) => (
                        <div className = {styles.container__photo} key={id}> 
                        <img  className={styles.photo} src={photo} alt="детский день рождения фото Ставрополь"/>
                        </div>
                    ))}
              
                </div>
        </section>
    );
}

export default Birthday;